import snsAxiosClient from '../common/http/http-sns';
import { get } from 'lodash';

function skipOrder(environmentVariables, user, skipOrderInfo) {
  const payload = { ...skipOrderInfo };
  const options = {
    headers: {
      ...get(environmentVariables, 'API_HEADERS_PATCH_V1'),
      Authorization: `Bearer ${get(user, 'authToken')}`,
    },
  };
  return snsAxiosClient(options).patch(
    `${get(environmentVariables, 'SNS_SKIP_ORDER')}${get(user, 'UUID')}/skipOrder`,
    payload,
  );
}

export default skipOrder;
